import type { PetModerationPackage } from '@exante/gyro-core';

export type { PetModerationPackage } from '@exante/gyro-core';
export type { PetOffboardingReview, PetOffboardingReceipt } from '@exante/gyro-core';
export type PetModerationAction = 'approve' | 'revoke' | 'quarantine';
export interface PetModerationInput {
  version: number;
  packageHash: string;
  action: PetModerationAction;
  reason: string;
}
export interface PetLibraryReport { id: string; packageId: string; version: number; reason: string; at: string }
export interface PetReviewQueue { items: PetModerationPackage[]; reports: PetLibraryReport[]; nextCursor: string | null }
export interface PetSupportStatus {
  storageReady: boolean;
  database: string;
  budgetConfigured: boolean;
  features: { create: boolean; run: boolean; replyDraft: boolean; library: boolean };
  runs: Record<string, number>;
  retainedRecords: Record<string, number>;
  workers: { healthy: number; stale: number; activeRuns: number };
}
export const PET_MODERATION_LABELS: Record<PetModerationAction, string> = {
  approve: 'Approve this version', revoke: 'Remove approval', quarantine: 'Quarantine this version',
};
export const PET_MODERATION_EFFECTS: Record<PetModerationAction, string> = {
  approve: 'Marks only this exact version as Approved and removes its quarantine. Other versions keep their own review status.',
  revoke: 'Removes the Approved badge from this exact version. Any quarantine remains in force. Personal copies are not deleted or paused by badge removal alone.',
  quarantine: 'Removes approval, hides this exact version from the library and blocks new work by personal copies using it, including active copies. In-flight external writes must be reconciled; this cannot undo work already performed. Personal copies are not deleted.',
};
